import { useRouter, type RouteRecordRaw } from 'vue-router';
import { NotFoundView, PaymentRequiredView } from '~/views/errors';

export const fallbackRoutes: RouteRecordRaw[] = [
    {
        // Reached only by the entitlement middleware, which stashes what was blocked in
        // the paywall store first -- so this renders correctly even on a cold load.
        name: '402',
        path: '/payment-required',
        component: PaymentRequiredView,
    },
    {
        name: '404',
        path: '/:catchAll(.*)*',
        component: NotFoundView,
        beforeEnter: (to, from, next) => {
            if (__DEBUG__) {
                console.error(`No route found for path: ${to.fullPath}`);
                console.log(JSON.parse(JSON.stringify(useRouter()?.getRoutes() ?? null)));
            }
            next();
        },
    },
];
